import { ReactElement } from "react";
import { UiLOneColumn } from "@rotorstudios/fe-ui";

import { UiDynamicRenderer } from "../../_common/modules/fe-ui/UiDynamicRenderer";
import useAdvantages from "./useAdvantages";

import "./_Advantages.scss";

const Advantages = (): ReactElement => {
  const { headerContent, mainContent, footerContent } = useAdvantages();

  const getHeaderContent = () => <UiDynamicRenderer data={headerContent} />;

  const getMainContent = () => <UiDynamicRenderer data={mainContent} />;

  const getFooterContent = () => <UiDynamicRenderer data={footerContent} />;

  return (
    <div className="Advantages">
      <UiLOneColumn
        headerContent={getHeaderContent()}
        mainContent={getMainContent()}
        footerContent={getFooterContent()}
      />
    </div>
  );
};

export default Advantages;
